import CreateWorkspaceIconPicker from './CreateWorkspaceIconPicker.jsx'
import CreateWorkspaceInlineInput from './CreateWorkspaceInlineInput.jsx'
import styles from './CreateWorkspace.module.scss'

export default function CreateWorkspaceFormBody({
  form,
  submitLabel,
  showHeading = true,
  heading = 'Create new workspace',
}) {
  const { name, setName, description, setDescription, icon, setIcon, canSubmit, nameError } = form
  return (
    <div className={styles.formShell}>
      {showHeading ? (
        <h2 id="add-workspace-title" className={styles.heading}>
          {heading}
        </h2>
      ) : null}
      <div className={styles.formRow}>
        <CreateWorkspaceIconPicker icon={icon} setIcon={setIcon} />
        <div className={styles.inputStack}>
          <CreateWorkspaceInlineInput
            value={name}
            onChange={setName}
            placeholder="Workspace name"
            inputClassName={styles.nameInput}
            ariaLabel="Workspace name"
          />
          {nameError ? <p className={styles.fieldError}>{nameError}</p> : null}
          <CreateWorkspaceInlineInput
            value={description}
            onChange={setDescription}
            placeholder="Description"
            inputClassName={styles.descriptionInput}
            rowClassName={styles.descriptionRow}
            ariaLabel="Description"
          />
        </div>
      </div>
      <div className={styles.formFooter}>
        <button type="submit" className={styles.submitButton} disabled={!canSubmit}>
          {submitLabel}
        </button>
      </div>
    </div>
  )
}
